import React from 'react';
import { TitleContainer } from './styles';
import { useMediaQueryGs } from 'app/hooks/useMediaQuery';
import { Trans } from 'react-i18next';

import { t } from 'i18next';
import { Colors, Text, Typography } from 'goalsetter-webapp-components';

type PortalTitleProps = {
  translation: string;
  values?: Record<string, string>;
};

function PortalTitle({ translation, values = {} }: PortalTitleProps) {
  const { isMobile } = useMediaQueryGs();

  if (t(translation).includes('®')) {
    return (
      <TitleContainer>
        <Trans
          i18nKey={t(translation)}
          values={values}
          components={{
            parent: (
              <Text
                type={isMobile ? Typography.GSH4 : Typography.GSH1}
                color={Colors.WHITE}
              >
                {}
              </Text>
            ),
            rm: (
              <Text
                type={isMobile ? Typography.GSH6 : Typography.GSH4}
                color={Colors.WHITE}
              >
                {}
              </Text>
            ),
          }}
        />
      </TitleContainer>
    );
  }
  return (
    <TitleContainer>
      <Text
        type={isMobile ? Typography.GSH4 : Typography.GSH1}
        color={Colors.WHITE}
      >
        {t(translation, values)}
      </Text>
    </TitleContainer>
  );
}

export default PortalTitle;
